import React from "react"

import VenueFooter from "@/components/public/venue/venue_footer"
import VenueImageGallery from "@/components/public/venue/venue_image_gallery"
import { PRIMARY_BLUE } from "@/constants/colors"
import i18n from "@/i18n"
import PublicTopBar from "@/pages/public/top_bar"
import useElementOutOfView from "@/shared/use_element_out_of_view"

import BookingFlow from "./booking_flow"
import type { ModalState, ModalAction, VenueType } from "./types"
import VenueContent from "./venue_content"

const STYLES = {
  container: "min-h-screen bg-white",
  content: "max-w-[1030px] mx-auto bg-white pb-24",
  galleryWrapper: "p-0",
  contentWrapper: "px-4 py-0",
  bookBar:
    "fixed bottom-0 left-0 right-0 z-50 border-t border-[#eaeaea] bg-white px-5 pb-[30px] pt-6 shadow-[0_-4px_4px_rgba(0,0,0,0.06)]",
  bookButton: "w-full h-[50px] rounded-[10px] text-base font-medium text-white",
} as const

type Props = {
  venue: VenueType
  venueLogoUrl: string | null
  modalState: ModalState
  dispatch: React.Dispatch<ModalAction>
}

const Mobile: React.FC<Props> = ({ venue, venueLogoUrl, modalState, dispatch }) => {
  const { targetRef: bookButtonRef, outOfView: headerCtaOutOfView } = useElementOutOfView<HTMLButtonElement>()

  return (
    <div className={STYLES.container} data-testid="public-venue-container">
      <PublicTopBar />

      <div className={STYLES.content} data-testid="public-venue-content">
        <div className={STYLES.galleryWrapper}>
          <VenueImageGallery images={venue.images || []} />
        </div>

        <div className={STYLES.contentWrapper}>
          <VenueContent
            venue={venue}
            onBookTable={() => dispatch({ type: "OPEN_MOBILE_BOOKING" })}
            bookButtonRef={bookButtonRef}
          />
        </div>
      </div>

      <VenueFooter />

      {!!headerCtaOutOfView && (
        <div className={STYLES.bookBar} data-testid="public-venue-mobile-book-bar">
          <button
            type="button"
            onClick={() => dispatch({ type: "OPEN_MOBILE_BOOKING" })}
            className={STYLES.bookButton}
            style={{ backgroundColor: PRIMARY_BLUE }}
            data-testid="public-venue-mobile-book-button"
          >
            {i18n.t("app.public.venue.book_table")}
          </button>
        </div>
      )}

      <BookingFlow venue={venue} venueLogoUrl={venueLogoUrl} modalState={modalState} dispatch={dispatch} />
    </div>
  )
}

export default Mobile
